import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getRewardPointsAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getRewardPointsAPI}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get reward points api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get reward points api err:", err);
            throw err;
        }
    };
};
export const getMilestonesAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getMilestonesAPI}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get milestones api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get milestones api err:", err);
            throw err;
        }
    };
};
export const getRewardPointUnitsAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getRewardPointUnitsAPI}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get reward point units api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get reward point units api err:", err);
            throw err;
        }
    };
};
export const getOrdersByRewardPointsAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getOrdersByRewardPointsAPI}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get orders by reward points api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get orders by reward points api err:", err);
            throw err;
        }
    };
};

//transaction type API
export const getTransactionTypeAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getTransactionTypeURL}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get transaction type api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get transaction type api err:", err);
            throw err;
        }
    };
}
//transaction status API
export const getTransactionStatusAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getTransactionStatusURL}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get transaction status api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get transaction status api err:", err);
            throw err;
        }
    };
}

export const getReferralsAPI = (params, callBack) => {
    return async () => {
        // Build query parameters if page_id exists
        let query = "";
        if (params && Object.keys(params).length > 0) {
            query = "?" + new URLSearchParams(params).toString();
        }
        const url = `${ApiConstants.getReferralsAPI}${query}`;
        try {
            await apiGet(url, params)
                .then((response) => {
                    callBack && callBack(response, response);
                })
                .catch((err) => {
                    console.log("get referrals api err===-=>>>:", err);
                    throw err;
                });
        } catch (err) {
            console.log("get referrals api err:", err);
            throw err;
        }
    };
}